export enum RemovedFilter {
  Blacklist = 1,
  Spams = 2,
  ConfirmationsFromFlow = 3,
  LostHumanVoice = 4,
  MainReasonProfessional = 5,
}

export const removedFilterMap: Record<number, string> = {
  [RemovedFilter.Blacklist]: "Contatos bloqueados",
  [RemovedFilter.Spams]: "Spans filtrados",
  [RemovedFilter.ConfirmationsFromFlow]: "Confirmações de consulta",
  [RemovedFilter.LostHumanVoice]: "Ligações rápidas (<10s)",
  [RemovedFilter.MainReasonProfessional]: "Contatos do profissional",
};
